import { BehaviorSubject } from 'rxjs';
import { BASE_API_URL } from '../envs.js';
let cancelInterval;
export function initializeObsoleteApiWatchdog() {
    if (!cancelInterval) {
        checkApiVersion();
        cancelInterval = setInterval(() => {
            checkApiVersion();
        }, 3600000 * 24);
    }
}
let initialVersion;
export const needsReload$ = new BehaviorSubject({
    reload: false,
    reason: 'initial',
});
async function checkApiVersion() {
    const r = await fetch(`${BASE_API_URL}/api/6/version.txt`, {
        priority: 'low',
        credentials: 'omit',
    });
    if (r.ok) {
        const currentVersion = await r.text();
        if (!initialVersion) {
            initialVersion = currentVersion;
            return;
        }
        if (initialVersion !== currentVersion) {
            needsReload$.next({
                reload: true,
                reason: 'API version mismatch',
            });
        }
    }
}
export async function monitorLoadingError(promise) {
    Promise.allSettled([promise]).then((results) => {
        switch (results[0].status) {
            case 'fulfilled':
                break;
            case 'rejected':
                needsReload$.next({
                    reload: true,
                    reason: 'rejected promise',
                });
                break;
        }
    });
    return promise;
}
//# sourceMappingURL=obsoleteApi.js.map